import { Action, ActionReducer } from "@ngrx/store";
import * as HydrationActions from "./hydration.actions";
import { AppStateInterface } from "src/app/appState.interface";
import { logout } from "../actions";
import { state } from "@angular/animations";
import { initialApplySelectedAssets, initialCompleteApplyState, initialDashboardState, initialFilterRefSetting, initialListStateTaAssetChooserRefFilter, initialListStateTabRefFilter, initialPeriod, initialSelectedAssets, initialState, initialStateUser, initialVehicleFilters, intialStateCustomerCache } from "../reducers";
import { DashboardData } from "../interface/dashboardData.interface";

function isHydrateSuccess(
  action: Action
): action is ReturnType<typeof HydrationActions.hydrateSuccess> {
  return action.type === HydrationActions.hydrateSuccess.type;
}

export const hydrationMetaReducer = (
  reducer: ActionReducer<AppStateInterface>
): ActionReducer<AppStateInterface> => {
  return (state, action) => {
    if (action.type === logout.type) {
      localStorage.clear();
        sessionStorage.clear();
        // lo store si resetta agli initialState

        const resetState: AppStateInterface = {
          ...state,
          getCustomers: initialState,
          getVehiclesOfCustomers: initialState,
          getTrailersOfCustomers: initialState,
          getFleetsOfCustomers: initialState,
          getDriversOfCustomers: initialState,
          getTeamsOfCustomers: initialState,
          setSelectedCustomerCache: intialStateCustomerCache,
          setTabFilterRef: initialListStateTabRefFilter,
          setTabAssetChooserRef: initialListStateTaAssetChooserRefFilter,
          user: initialStateUser,
          applySelectedCustomer: intialStateCustomerCache,
          setSelectedAssets: initialSelectedAssets,
          applySelectedAssets: initialApplySelectedAssets,
          setSelectedPeriod: initialPeriod,
          applySelectedPeriod: initialPeriod,
          completeApplyState: initialCompleteApplyState,
          filterRefSetting: initialFilterRefSetting,
          vehicleFilters: initialVehicleFilters,
          dashboards: { dashboards: initialDashboardState, isLoading: false, error: null },
          dashboardData: {} as DashboardData
      };
        return reducer(resetState, { type: '@@INIT' });
    }

    if (isHydrateSuccess(action) && state) {
      return action.state;
    }

    return reducer(state, action);

  };
};
